import {
  WecAiBookingNotAcceptedSchedulerFeatureName,
  WecAiMissingPocPodSchedulerFeatureName,
  WecAiCollectionDeliveryDelaySchedulerFeatureName,
  WecAiDriverOnboardingSchedulerFeatureName,
  WecAiETAProviderSchedulerFeatureName,
} from 'constants/EntityConstants/AppFeature'
import {
  BookingNotAcceptedByDriver,
  MissingPocPod,
  CollectionDeliveryDelay,
  DriverOnboard,
  EtaProvider,
} from 'constants/EntityConstants/SchedulerAttempts'

export const GetWecAiAppFeatureNameFromSchedulerType = (schedulerType: string): string => {
  switch (schedulerType) {
    case BookingNotAcceptedByDriver:
      return WecAiBookingNotAcceptedSchedulerFeatureName
    case MissingPocPod:
      return WecAiMissingPocPodSchedulerFeatureName
    case CollectionDeliveryDelay:
      return WecAiCollectionDeliveryDelaySchedulerFeatureName
    case DriverOnboard:
      return WecAiDriverOnboardingSchedulerFeatureName
    case EtaProvider:
      return WecAiETAProviderSchedulerFeatureName
    default:
      throw new Error(`Unsupported scheduler type: ${schedulerType}`)
  }
}
